module.exports = __webpack_public_path__ + "img/Partners12.0e7559dd.png";